/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'

const RecoveryPasswordOptions = ({
  icon,
  isTouched,
  onClick,
  content = {
    title: '',
    description: ''
  }
}) => (
  <div
    role='button'
    tabIndex={0}
    onClick={onClick}
    className={`${
      isTouched ? 'bg-white ring-2 ring-green-400' : 'bg-white'
    } cursor-pointer h-20 px-3 gap-3 w-full rounded-md mt-4 shadow-md flex flex-row items-center`}
  >
    <div>{icon}</div>
    <div
      className={`flex flex-col font-manrope  w-full text-black justify-center `}
    >
      <span className='font-bold leading-5 text-base'>{content.title}</span>
      <span className='leading-4 font-medium text-xs text-black'>
        {content.description}
      </span>
    </div>
  </div>
)

export default RecoveryPasswordOptions
